import React, { FC } from 'react';
import { Button } from 'antd';
import { StyledButtonsBlock } from '../styles';

interface MultiDatePickerFooterProps {
  OkClick: () => void;
  cancelClick: () => void;
}

const MultiDatePickerFooter: FC<MultiDatePickerFooterProps> = ({
  OkClick: onOkClick,
  cancelClick: onCancelClick,
}): JSX.Element => {
  return (
    <StyledButtonsBlock>
      <Button onClick={onOkClick} type="primary">
        Ok
      </Button>
      <Button onClick={onCancelClick} type="text" className="cancel">
        Cancel
      </Button>
    </StyledButtonsBlock>
  );
};

export default MultiDatePickerFooter;
